// Cxs is mandatory here, cannot test branch coverage
const themeBackgroundColor = (theme = {}, cxs) =>
  theme.paletteSecondary &&
  cxs({
    backgroundColor: `${theme.paletteSecondary} !important`,
  });

// Cxs is mandatory here, cannot test branch coverage
const themeFontColor = (theme = {}, cxs) =>
  theme.keyLightBase &&
  cxs({
    color: `${theme.keyLightBase} !important`,
  });

// Cxs is mandatory here, cannot test branch coverage
const headerBackgroundIcon = (cxs) =>
  cxs &&
  cxs({
    backgroundRepeat: 'no-repeat !important',
    backgroundSize: 'contain !important',
  });

// Cxs is mandatory here, cannot test branch coverage
const themeHeadingFontColor = (theme = {}, cxs) =>
  theme.keyLightBase &&
  cxs({
    color: `${theme.keyLightBase} !important`,
  });

// Cxs is mandatory here, cannot test branch coverage
const themePartnerTextColor = (theme = {}, cxs) =>
  theme.fontColor &&
  cxs({
    color: `${theme.fontColor} !important`,
  });

// Cxs is mandatory here, cannot test branch coverage
const headerBackgroundColor = (color, cxs) =>
  color &&
  cxs &&
  cxs({
    backgroundColor: `${color} !important`,
  });

export default {
  themeBackgroundColor,
  themeFontColor,
  headerBackgroundIcon,
  themeHeadingFontColor,
  themePartnerTextColor,
  headerBackgroundColor,
};
